// Checkers' client registry entry (see ../registry.ts and docs/games-contract.md).
// The views are the shared board-game views (../board) driven by checkersUi.

import React from 'react';
import { Disc3 } from 'lucide-react';
import { BoardTableSet } from '../board/BoardTableSet';
import { BOARD_CHAIRS, BOARD_FOOTPRINT } from '../board/boardLayout';
import { BoardOverlay } from '../board/BoardOverlay';
import { BoardTable3D } from '../board/BoardTable3D';
import { BoardVRPanel } from '../board/BoardVRPanel';
import { checkersUi, CHECKERS_RULES, CHECKERS_TUTORIAL, SEAT_NAMES } from './checkersUi';
import type { GameClientDef, OverlayProps, Table3DProps, VRPanelProps } from '../types';

function CheckersOverlay(props: OverlayProps) {
  return <BoardOverlay {...props} ui={checkersUi} footer="Play a friend, or the computer." />;
}
function CheckersTable3D(props: Table3DProps) {
  return <BoardTable3D {...props} ui={checkersUi} />;
}
function CheckersVRPanel(props: VRPanelProps) {
  return <BoardVRPanel {...props} ui={checkersUi} />;
}

export const checkersClient: GameClientDef = {
  kind: 'checkers',
  label: 'Checkers',
  blurb: 'American checkers for 2 — jumps are mandatory. Play a friend or the computer.',
  icon: Disc3,
  glyph: '⛀',
  category: 'table',
  minPlayers: 2,
  maxPlayers: 2,
  bots: true,
  seatNames: SEAT_NAMES,
  ranking: 'wins',
  chairs: BOARD_CHAIRS,
  footprint: BOARD_FOOTPRINT,
  Furniture: BoardTableSet,
  Table3D: CheckersTable3D,
  Overlay: CheckersOverlay,
  VRPanel: CheckersVRPanel,
  rules: CHECKERS_RULES,
  tutorial: CHECKERS_TUTORIAL,
};
